<template>
  <draggable class="padded" :list="indices" :group="{ name: 'g1' }">
    <div v-for="(idx,i) in indices" v-bind:key="'idx-'+i">

      <div v-if="type === 'index'" class="row-index dragArea">
        <div class="col-index col-index-15">
          <ion-input placeholder="Ref" :value="idx.ref" @ionInput="indices[i].ref = $event.target.value;"></ion-input>
        </div>
        <div class="col-index col-index-15">
          <ion-input placeholder="Cod" :value="idx.cod" @ionInput="indices[i].cod = $event.target.value;"></ion-input>
        </div>
        <div class="col-index col-index-3">
          <ion-input placeholder="Title" :value="idx.title" @ionInput="indices[i].title = $event.target.value;"></ion-input>
        </div>
        <div class="col-index col-index-25">
          <select v-model="idx.type">
            <option value="">Type</option>
            <option value="tt">Text/Tables</option>
            <option value="in">Item</option>
          </select>
        </div>
        <div class="col-index col-index-15" v-if="!idx.indices.length">
          <span class="btn-link" @click="() => remove(i, indices)">Remove</span>
        </div>
      </div>

      <div v-if="type === 'worklist'" class="row-index dragArea">
        <div class="col-index col-index-30">
          <ion-input placeholder="Ref" :value="idx.ref_number" @ionInput="indices[i].ref_number = $event.target.value;"></ion-input>
        </div>
        <div class="col-index col-index-60">
          <ion-input placeholder="Title" :value="idx.title" @ionInput="indices[i].title = $event.target.value;"></ion-input>
        </div>
        <div class="col-index col-index-15">
          <span class="btn-link" @click="() => remove(i, indices)">Remove</span>
        </div>
      </div>

      <nested-draggable
          v-if="type === 'index'"
          @add="(i) => add(i)"
          @remove="(i) => remove(i, indices)"
          :k="k+1"
          :indices="idx.indices"
          type="index"
      />
      <nested-draggable
          v-if="type === 'worklist'"
          @add="(i) => add(i)"
          @remove="(i) => remove(i, indices)"
          :k="k+1"
          :indices="idx.indices"
          type="worklist"
      />

    </div>

    <ion-button v-if="k == 0" class="btn-icon" @click="add(0)"><img src="../../assets/svg/icon-add.svg"></ion-button>

  </draggable>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: "NestedDraggable",
  props: ['indices', 'k', 'type'],
  components: {
    draggable
  },
  methods: {
    add: function(i) {
      this.$emit('add', i)
    },
    remove: function(i, indices) {
      indices.splice(i,1)
    }
  },
  created: function(){
  }
};
</script>
<style scoped>
.dragArea {
  padding-top: 5px;
  padding-bottom: 5px;
}
.padded {
  padding: 20px;
  border: 1px dashed;
  min-height: 10px;
  margin-bottom: 20px;
}
</style>
